// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { salesPersonRoute, salesPersonRouteAbsolute } from '../roleRoutes/salesPerson';
// Styles, images, icons
import { icons } from '~/assets';

export const privateSalesPersonRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: salesPersonRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: salesPersonRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: salesPersonRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: salesPersonRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: salesPersonRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: salesPersonRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}${salesPersonRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: salesPersonRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}${salesPersonRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: salesPersonRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: salesPersonRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.jobs}${salesPersonRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: salesPersonRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: salesPersonRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: salesPersonRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: salesPersonRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.quotes}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: salesPersonRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.order}${salesPersonRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.order}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: salesPersonRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: salesPersonRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.invoice}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.quotes}${salesPersonRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: salesPersonRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: salesPersonRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: salesPersonRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: salesPersonRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: salesPersonRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}${salesPersonRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}${salesPersonRoute.commonDetail}${salesPersonRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Package
  {
    path: salesPersonRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: salesPersonRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: salesPersonRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: salesPersonRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: salesPersonRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: salesPersonRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: salesPersonRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: salesPersonRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.purchaseOrder}${salesPersonRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: salesPersonRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: salesPersonRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}${salesPersonRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: salesPersonRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: salesPersonRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}${salesPersonRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: salesPersonRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: salesPersonRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: salesPersonRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.roleManagement}${salesPersonRoute.commonDetail}${salesPersonRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: salesPersonRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: salesPersonRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: salesPersonRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: salesPersonRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
